import styles from './SchoolList.styles';
import { Subscription } from '@/graphql/types';
import { BodySmallMidEmphasis } from '@/design-system';
import colors from '@/theme/colors';
import { useNavigate } from 'react-router-dom';
import { AccessibleDivButton, AccessibleList, AccessibleListItem } from '@/components';

interface SchoolListProps {
  schools: Array<Subscription>;
  otherSchoolsAmount: number;
}

export const SchoolList: React.FC<SchoolListProps> = ({ schools, otherSchoolsAmount }) => {
  const navigate = useNavigate();
  const onClick = (schoolId: string) => navigate(`/explore/all?audienceId=${schoolId}`);

  return (
    <AccessibleList className={styles.container}>
      {schools &&
        schools.map(({ id, name }) => (
          <AccessibleListItem key={id}>
            <AccessibleDivButton
              className={styles.card}
              onClick={() => onClick(id)}
              role="link"
              tabIndex={3}
            >
              <BodySmallMidEmphasis as="span" className={styles.text} data-testid="schoolName">
                {name}
              </BodySmallMidEmphasis>
            </AccessibleDivButton>
          </AccessibleListItem>
        ))}
      {otherSchoolsAmount > 0 && (
        <AccessibleListItem>
          <BodySmallMidEmphasis as="span" color={colors.slate} data-testid="otherSchools">
            {`+ ${otherSchoolsAmount} other schools in the district`}
          </BodySmallMidEmphasis>
        </AccessibleListItem>
      )}
    </AccessibleList>
  );
};
